/**
 * 通过 navigator.userAgent 判断当前是否为移动端
 * @returns {boolean} true 表示移动端，false 表示 PC 端
 */
export function isMobile() {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : ''
  const mobileReg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i
  return mobileReg.test(ua)
}
